import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

import { useGetOnboardingInsights } from '@/apis/agency/onboardingInsights/hooks';
import { BuilderEmptyStateView } from '@/components/Common/BuilderEmptyStateView';

import AIReceptionistReasonsChart from './insights/AIReceptionistReasonsChart';
import MonthlyOnboardingTrendChart from './insights/MonthlyOnboardingTrendChart';
import OnboardingInsightsSkeleton from './insights/OnboardingInsightsSkeleton';
import SourceBreakdownChart from './insights/SourceBreakdownChart';
import StatusBreakdownChart from './insights/StatusBreakdownChart';
import SummaryCards from './insights/SummaryCards';

function InsightsUnavailableState({ message }: { message: string }) {
  return (
    <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} py={6}>
      <BuilderEmptyStateView
        message={
          <Box textAlign='center'>
            <Typography fontSize={14} color='text.secondary' mb={2}>
              {message}
            </Typography>
          </Box>
        }
      />
    </Box>
  );
}

export default function OnboardingInsights() {
  const { data, isLoading } = useGetOnboardingInsights({ retry: false });

  if (isLoading) {
    return <OnboardingInsightsSkeleton />;
  }

  if (!data) {
    return <InsightsUnavailableState message='No insights data available yet.' />;
  }

  return (
    <>
      <SummaryCards
        avgBusinessSetupTime={data.avg_business_setup_time}
        avgAgentDeliveryTime={data.avg_agent_delivery_time}
        avgGoLiveTime={data.avg_go_live_time}
      />
      <MonthlyOnboardingTrendChart data={data.monthly_completed_trend ?? []} />
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <StatusBreakdownChart data={data.status_breakdown ?? []} />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <SourceBreakdownChart data={data.source_breakdown ?? []} />
        </Grid>
      </Grid>
      <AIReceptionistReasonsChart data={data.ai_receptionist_reasons_breakdown ?? []} />
    </>
  );
}
